import { render } from "./loader.svg?vue&type=template&id=37495f2e?inline"
const script = {}
script.render = render

export default script